@if (form) {
    <form [formGroup]="form" fxLayout="row" fxLayoutAlign="start center">
        <div class="icon-button pointer" fxLayout="row" fxLayoutAlign="center center"
             [class.disabled]="form.invalid || form.disabled"
             (click)="form.valid && form.enabled && shiftRange(-1)">
            <ui-kit-svg name="ic_arrow_left" class="i-24"
                        [class.c-primary-gray-900]="form.valid && form.enabled"
                        [class.c-primary-gray-400]="form.invalid || form.disabled"/>
        </div>
        <mat-form-field class="ml-4">
            <mat-select #matSelect
                        [(value)]="dateRange"
                        hideSingleSelectionIndicator
                        [placeholder]="placeholder | translate"
                        (valueChange)="handleSelection($event)"
                        panelClass="hide-scroll-bar"
                        [disabled]="form.disabled">
                <mat-select-trigger class="t1"
                                    panelClass="hide-scroll-bar"
                                    [class.c-primary-gray-900]="form.enabled"
                                    [class.c-primary-gray-400]="form.disabled">
                    {{ displayValue || ('i18n_lib_commonRangeFilter#' + dateRange) | translate }}
                </mat-select-trigger>
                @for (range of sortedPickerRange; track range) {
                    <mat-option [value]="range"
                                (click)="range === PickerRange.SELECT_RANGE && picker.open()">
                        {{ 'i18n_lib_commonRangeFilter#' + range | translate }}
                    </mat-option>
                }
            </mat-select>
            <ui-kit-svg matIconPrefix
                        class="i-16 circle pointer p-8 ml-8 c-primary-gray-600"
                        name="ic_calendar"
                        (click)="$event.stopPropagation(); picker.open()"/>
            <ui-kit-calendar #picker
                             mode="date-range-picker"
                             [showPickerActions]="true"
                             [dateStartControl]="form.controls.dateFrom"
                             [dateEndControl]="form.controls.dateTo"
                             [disabled]="form.disabled"
                             [monthLock]="singleMonth">
                <div PickerActions class="w-100" fxLayout="column" fxLayoutAlign="start center">
                    @if (withTime && startTimeControl && endTimeControl) {
                        <ui-kit-time-range [startControl]="startTimeControl"
                                           [endControl]="endTimeControl"
                                           class="w-100 mb-16"/>
                    }
                    <div class="w-100" fxLayout="row" fxLayoutAlign="center center">
                        <ui-kit-button [label]="'i18n_lib_commonButtonDone' | translate"
                                       fxFlex
                                       (clickListener)="selectDate()"/>
                    </div>
                </div>
            </ui-kit-calendar>
        </mat-form-field>
        <div class="icon-button ml-4 pointer" fxLayout="row" fxLayoutAlign="center center"
             [class.disabled]="form.invalid || form.disabled"
             (click)="form.valid && form.enabled && shiftRange(1)">
            <ui-kit-svg name="ic_arrow_right"
                        class="i-24"
                        [class.c-primary-gray-900]="form.valid"
                        [class.c-primary-gray-400]="form.invalid || form.disabled"/>
        </div>
    </form>
}
